module.exports = __webpack_public_path__ + "static/power3-3@2x-e5f6d965651f05dd9ab4c5f8b730f6a2.png";